/**
 * Determines whether a given value is null@
 */
export function isNull(value: any): value is null {
  return value === null;
}

/**
 * Determines whether a given value is undefined
 */
export function isUndefined(value: any): value is undefined {
  return value === undefined;
}

/**
 * Determines whether a given value is null or undefined
 */
export function isNullish(value: any): value is null | undefined {
  return isNull(value) || isUndefined(value);
}
